var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website pages"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.429 9.75L2.25 12L6.429 14.25M6.429 9.75L12 12.75L17.571 9.75M6.429 9.75L2.25 7.5L12 2.25L21.75 7.5L17.571 9.75M6.429 14.25L2.25 16.5L12 21.75L21.75 16.5L17.571 14.25M6.429 14.25L12 17.25L17.571 14.25M17.571 9.75L21.75 12L17.571 14.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/modules.3a364f9fea30c4df34ea9f2b03b09099.svg";
export { ForwardRef as ReactComponent };